import { render, staticRenderFns } from "./Topbar2.vue?vue&type=template&id=3e8ac4ef&"
import script from "./Topbar2.vue?vue&type=script&lang=js&"
export * from "./Topbar2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports